<template>
  <div class="role">
    <div class="roleBody">
      <div class="bodyHeader">
        <el-form
          ref="search"
          label-width="90px"
          :model="searchForm"
          style="
            width: 95%;
            margin: 15px auto;
            display: flex;
            justify-content: space-between;
          "
        >
          <el-form-item label="角色名称" class="item" prop="roleName">
            <el-input
              v-model="searchForm.roleName"
              clearable
              style="width: 160px"
              placeholder="请输入登录名称"
            />
          </el-form-item>
          <el-form-item label="省份:" prop="province">
            <el-select
              v-model="searchForm.province"
              placeholder="请选择省份"
              clearable
              style="width: 140px"
            >
              <el-option
                v-for="(t, i) in provinceData"
                :key="i"
                :label="t.label"
                :value="t.value"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="权限字符" class="item">
            <el-input
              v-model="searchForm.user"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="角色状态" class="item">
            <el-input
              v-model="searchForm.user"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="开始时间" prop="beginTime">
            <el-date-picker
              v-model="searchForm.beginTime"
              type="date"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
              style="width: 140px"
            />
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              :picker-options="endDate"
              placeholder="结束时间"
              value-format="yyyy-MM-dd"
              style="width: 140px"
            />
          </el-form-item>
          <el-form-item label-width="0px" style="width: 15%; min-width: 160px">
            <template>
              <el-button
                size="small"
                icon="el-icon-refresh-left"
                style="
                  color: #4170ff;
                  border-radius: 20px;
                  border-color: #4170ff;
                "
                @click="reset"
              >重置</el-button>
              <el-button
                size="small"
                style="
                  color: #fff;
                  border-radius: 20px;
                  background: #4170ff;
                  border-color: #4170ff;
                "
                icon="el-icon-search"
                @click="searchHandle"
              >搜索</el-button>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="roleBody">
        <div style="width: 95%; display: flex; margin: 0 auto">
          <div class="bodyTable">
            <div class="addmessheader">
              <!-- <el-button
                type="primary"
                class="addmess"
                size="mini"
                icon="el-icon-upload2"
              >
                导出</el-button
              > -->
              <el-button
                type="primary"
                class="addmess"
                size="mini"
                icon="el-icon-circle-plus-outline"
                @click="addItem(false)"
              >新增</el-button>
              <el-button
                type="primary"
                class="addmess"
                size="mini"
                icon="el-icon-menu"
                @click="addItem(true)"
              >角色类型批量处理</el-button>
            </div>
            <el-table
              border
              :data="tableData"
              :header-cell-style="{
                'text-align': 'center',
                background: '#f4f4f4',
              }"
              :cell-style="{ 'text-align': 'center' }"
              style="width: 100%"
            >
              <el-table-column prop="roleId" label="角色编号" />
              <el-table-column prop="roleName" label="角色名称" />
              <el-table-column
                prop="roleType"
                label="角色类型"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  types[scope.row.roleType] || scope.row.roleType
                }}</template>
              </el-table-column>
              <el-table-column prop="provinceName" label="省份" />
              <el-table-column prop="remark" show-overflow-tooltip label="备注" />
              <el-table-column prop="cjsj" min-width="170px" label="创建时间" />
              <!-- <el-table-column prop="zt" label="角色状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.zt"
                    active-value="00"
                    inactive-value="01"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" fixed="right" width="200px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="editItem(scope.row)"
                  >编辑</el-button>
                  <el-button
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="deleteItem(scope.row)"
                  >删除</el-button>
                  <!-- <el-button
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="dataAuthority(scope.row)"
                    >数据权限</el-button
                  >
                  <el-button
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    v-preventReClick
                    @click="distributionUser"
                    >分配用户</el-button
                  > -->
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              background
              layout="prev,pager,next,jumper,total,sizes"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dataDialogVisible"
      width="500px"
      center
    >
      <div slot="title" class="header-title">
        <span>数据权限</span>
      </div>
      <el-form label-position="left" style="width: 75%; margin: 30px auto">
        <el-form-item label="角色名称" label-width="80px">
          <el-input v-model="dataAuthorityForm.username" />
        </el-form-item>
        <el-form-item label="权限字符" label-width="80px">
          <el-input v-model="dataAuthorityForm.password" />
        </el-form-item>
        <el-form-item label="数据范围" label-width="80px">
          <el-input v-model="dataAuthorityForm.password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; border-color: #4170ff"
          @click="sureSubmit"
        >确 认</el-button>
      </span>
    </el-dialog>
    <role-dialog ref="roleDialog" @refresh="loadData" />
  </div>
</template>
<script>
import roleDialog from '@/components/role/roleDialog.vue'
import { getRoleList, getRoleType, getProvince, deleteRole } from '@/assets/js/role'
export default {
  name: 'User',
  components: { roleDialog },
  data() {
    return {
      dataAuthorityForm: {
        // 重置密码
        username: '',
        password: ''
      },
      provinceData: [],
      searchForm: {
        roleName: '', // 角色名称
        province: '', // 省份的id
        beginTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      dataDialogVisible: false, // 数据权限
      centerDialogVisible: false, // 确认删除信息提示
      currentPage: 1, // 当前页
      pagesize: 5, // 每页的数据条数
      total: 0,
      data: [],
      tableData: [],
      types: {},
      roleType: []
    }
  },
  computed: {
    endDate() {
      const beginTime = this.searchForm.beginTime
      return {
        disabledDate(time) {
          if (beginTime) {
            return new Date(time).getTime() < new Date(beginTime).getTime() - 1000 * 60 * 60 * 24
          }
          return false
        }
      }
    }
  },
  watch: {},
  created() { },
  mounted() {
    this.loadProvince()
    this.loadDict()
    this.loadData()
  },
  beforeDestroy() { },
  methods: {
    reset() {
      this.$refs['search'].resetFields()
      this.searchHandle()
    },
    loadDict() {
      getRoleType().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          // 成功
          this.roleType = res.data.data
          res.data.data.forEach(d => {
            this.types[d.value] = d.label
          })
        }
      })
    },
    searchHandle() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      getRoleList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          // 成功
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    handleNodeClick(data) {
      console.log(data)
    },
    // 重置密码
    dataAuthority(row) {
      this.dataDialogVisible = true
    },
    // 分配角色
    distributionUser() {
      this.$refs.roleDialog.dialogjsVisible = true
    },
    // 添加
    addItem(flag) {
      this.$refs.roleDialog.show(flag, {})
    },
    loadProvince() {
      getProvince().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.provinceData = res.data.data
        }
      })
    },
    // 数据权限
    sureSubmit() {
      this.$confirm('确认执行提交操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '提交成功'
          })
          this.dataDialogVisible = false
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消提交'
          })
        })
    },
    // 删除
    deleteItem(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRole(row.roleId).then(res => {
          if (res.status === 200 && res.data.code === '000000') {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.loadData()
          }
        })
      })
    },
    // 编辑
    editItem(row) {
      this.$refs.roleDialog.show(false, row)
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
    }
  }
}
</script>
<style scoped lang='less'>
.role {
  .roleBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      .el-form-item {
        width: 20%;
      }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .roleBody {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 57px;
      // padding-right: 30px;
      .bodyTable {
        width: 100%;
        margin: 0 auto;
        .addmessheader {
          background: #f4f4f4;
          .addmess {
            margin: 12px 0 12px 8px;
          }
        }
        .el-button--primary {
          color: #fff;
          background: #4170ff;
          border-radius: 3px;
          border-color: #4170ff;
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  .header-title {
    text-align: center;
  }
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
